import { ajax } from "rxjs/ajax";
export const BASE_API_DOMAIN = process.env.MIX_APP_URL || "https://account.amplify.localhost";
export const headers = {
    "Content-Type": "application/json",
};
export const redirectConfig = {
    defaultRedirect: '/page-not-found',
    redirectByStatus: {
        404: '/login',
        401: '/login'
    }
};
export const httpClient = ajax;
